export const about = [
  {
    name: "Contact Us",
  },
  {
    name: "About Us",
  },
  {
    name: "Careers",
  },
  {
    name: "Flipkart Stories",
  },
  {
    name: "Press",
  },
  {
    name: "Flipkart Wholesale",
  },
  {
    name: "Corporate Information",
  },
];

export const help = [
  {
    name: "Payments",
  },
  {
    name: "Shipping",
  },
  {
    name: "Cancellation & Returns",
  },
  {
    name: "FAQ",
  },
  {
    name: "Report Infringement",
  },
];

export const policy = [
  {
    name: "Return Policy",
  },
  {
    name: "Terms Of Use",
  },
  {
    name: "Security",
  },
  {
    name: "Privacy",
  },
  {
    name: "Sitemap",
  },
  {
    name: "EPR Compliance",
  },
];

export const social = [
  { name: "Facebook" },
  { name: "Twitter" },
  { name: "YouTube" },
];
